import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FieldService } from '../field/field.service';
import { EngineTagEventPersonalService, EngineTagService, TagDTO, TagStatusDTO } from '@tj/tj-dmp-lib-api';
import { switchMap, tap } from 'rxjs/operators';

@Component({
    selector: 'dmp-field-tag',
    templateUrl: './field-tag.component.html',
    styleUrls: ['./field-tag.component.scss'],
    standalone: false
})
export class FieldTagComponent implements OnInit, OnChanges {
    /** Contact dont on affiche les tags ; par défaut la ligne de la fiche (vue de contacts). */
    @Input() personalId: number;
    /** Lecture seule même en mode édition : les tags du client, sur la fiche d'une commande. */
    @Input() readonly = false;

    data: TagStatusDTO[] = [];
    originData: TagStatusDTO[] = [];
    tags: TagDTO[] = [];
    tagAdded: any;
    tagsOptions: TagDTO[] = [];

    dirty = false;
    loaded = false;

    constructor(public fieldService: FieldService,
        private engineTagEventPersonalService: EngineTagEventPersonalService,
        private engineTagService: EngineTagService) {
        this.fieldService.addTag(this);
    }

    get targetPersonalId(): number {
        return this.personalId ?? this.fieldService.data.mainData.id;
    }

    get editable(): boolean {
        return !this.readonly && this.fieldService.mode === 'EDIT';
    }

    get hasActiveTags(): boolean {
        return this.data.some(d => d.status);
    }

    ngOnInit(): void {
        if (this.targetPersonalId == null) {
            this.loaded = true;
            return;
        }
        this.engineTagEventPersonalService.findTagsByPersonal(this.fieldService.datastore, this.targetPersonalId)
            .subscribe((data) => {
                this.data = data;
                this.originData = JSON.parse(JSON.stringify(this.data));
                this.loaded = true;
                this.updateTagOption();
            });
        if (!this.readonly) {
            this.engineTagService.getAllTags(this.fieldService.datastore, true, 0, 1000).subscribe(data => {
                this.tags = data;
                this.updateTagOption();
            });
        }
    }

    delete(item: TagStatusDTO) {
        item.status = false;
        this.updateTagOption();
        this.dirty = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
    }
    
    updateTagOption() {
        const idsTag = this.data.filter(d => d.status).map(d => d.tagId);
        this.tagsOptions = this.tags.filter(t => !idsTag.includes(t.id));
    }

    addTag($event: any) {
        this.dirty = true;
        const tag = $event.value as TagDTO;
        const tagData = this.data.find(d => d.tagId === tag.id);
        if (tagData) {
            tagData.status = true;
        } else {
            this.data.push({
                tagId: tag.id,
                tagName: tag.name,
                partner: tag.partners?.join(', '),
                status: true
            } as TagStatusDTO);
        }
        this.updateTagOption();
        this.tagAdded = null;
    }

    isDirty() {
        return this.dirty;
    }

    cancel() {
        this.data = JSON.parse(JSON.stringify(this.originData));
        this.updateTagOption();
        this.dirty = false;
    }

    save() {
        const statusByTags: { [key: string]: boolean; } = {};

        const deleteTag = this.data.filter(d => !d.status && d.tepId != null);
        deleteTag.forEach(t => statusByTags[t.tagId] = false);

        const newTag = this.data.filter(d => d.tepId == null && d.status);
        newTag.forEach(t => statusByTags[t.tagId] = true);
        
        if ((deleteTag.length + newTag.length) > 0) {
            this.engineTagEventPersonalService
                .updatePersonalTag(statusByTags, this.fieldService.datastore, this.targetPersonalId).pipe(
                    switchMap(() => this.engineTagEventPersonalService.findTagsByPersonal(this.fieldService.datastore, this.targetPersonalId)),
                    tap((data) => {
                        this.data = data;
                        this.originData = JSON.parse(JSON.stringify(this.data));
                        this.updateTagOption();
                        this.dirty = false;
                    })
                )
                .subscribe();
        }
    }

}
